import { render, staticRenderFns } from "./SchoolPackageAssignPage.vue?vue&type=template&id=0d488532"
import script from "./SchoolPackageAssignPage.vue?vue&type=script&lang=js"
export * from "./SchoolPackageAssignPage.vue?vue&type=script&lang=js"
import style0 from "./SchoolPackageAssignPage.vue?vue&type=style&index=0&id=0d488532&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d488532')) {
      api.createRecord('0d488532', component.options)
    } else {
      api.reload('0d488532', component.options)
    }
    module.hot.accept("./SchoolPackageAssignPage.vue?vue&type=template&id=0d488532", function () {
      api.rerender('0d488532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/SchoolPackageAssignPage.vue"
export default component.exports